const swellLevelAmount = {
    au: { silver: 'Spend $450', gold: 'Spend $800' },
    ca: { silver: 'Spend $450', gold: 'Spend $700' },
    us: { silver: 'Spend $300', gold: 'Spend $500' },
    uk: { silver: 'Spend £250', gold: 'Spend £500' },
    eu: { silver: 'Spend €275', gold: 'Spend €500' },
    fr: { silver: 'Spend €275', gold: 'Spend €500' },
};

const swellDef = {
    vipTiers: [{
        levelAmount: 'Create an account',
        levelLabel: 'Create an account',
        level: 'Level 1',
        multiplier: '1X',
        discount: ["<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", '', '',''],
        bgColor: '#d5f3ff'
    }, {
        levelAmount: swellLevelAmount[window.siteEnv] ? swellLevelAmount[window.siteEnv].silver : swellLevelAmount.us.silver,
        level: 'Silver',
        levelLabel: 'Spend',
        multiplier: '2X',
        discount: ["<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", '', "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", '', "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>"],
        bgColor: '#ffebed'
    }, {
        levelAmount: swellLevelAmount[window.siteEnv] ? swellLevelAmount[window.siteEnv].gold : swellLevelAmount.us.gold,
        level: 'Gold',
        levelLabel: 'Spend',
        multiplier: '3X',
        discount: ["<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", '', '', "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>", "<img src='//uk.sandandsky.com/cdn/shop/t/108/assets/swell-vip-check.png?v=21997177996268936931766636365' alt='' loading='lazy'>"],
        bgColor: '#f0c7e1'
    }],
    redemptionsExclusions: [{
        name: "TEST12345"
    }],
    referralShareLinks: [{
            class: "swell-share-referral-facebook",
            href: "javascript:void(0)",
            icon: "fa fa-facebook",
            text: "Share",
            /* img: "//uk.sandandsky.com/cdn/shop/t/108/assets/swell-message-icon.png?v=48498" */
        },
        {
            class: "swell-share-referral-messenger",
            href: "javascript:void(0)",
            icon: "fa fa-commenting",
            text: "Message",
            /*img: "//uk.sandandsky.com/cdn/shop/t/108/assets/swell-fb-message.png?v=48498"*/
        },
        {
            class: "swell-share-referral-twitter",
            href: "javascript:void(0)",
            icon: "fa fa-twitter",
            text: "Tweet",
            /* img: "//uk.sandandsky.com/cdn/shop/t/108/assets/swell-tweet-icon.png?v=48498" */
        },
        {
            class: "swell-share-referral-sms",
            href: "javascript:void(0)",
            icon: "fa fa-mobile",
            text: "SMS",
            /*img: "//uk.sandandsky.com/cdn/shop/t/108/assets/swell-sms.png?v=48498"*/
        }
    ],
    referralForms: {
        newUserForm: {
            inputType: "text",
            submitText: "Next",
            labelText: "",
            placeholder: "Enter your email to get started..",
            formType: "new"
        },
        existingUserForm: {
            inputType: "text",
            submitText: "Share the love!",
            labelText: "",
            placeholder: "Now, enter your friends' emails (separated by commas)",
            formType: "existing"
        },
        externalContent: {
            referralEmailExists: "Enter your email",
            referralEmailExistsForm: {
                inputs: [{
                        type: "text"
                    },
                    {
                        name: "email"
                    },
                    {
                        placeholder: "Enter your email"
                    }
                ]
            }
        }
    },
    redemptionsExclusions: [{}]
};
